<template>
  <div>
    <div class="agreement_content">
      <h3 class="agreement_title">启航教育在线用户协议</h3>
      <div class="agreement_text">
        <div class="agreement_paragraph">
          <h5>一、说明</h5>
          <p>
            本用户协议双方为北京爱启航网络科技有限公司（下称“启航教育在线”）与启航教育在线网络用户，本用户协议具有合同效力。本用户协议内容包括协议正文及所有启航教育在线已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。在本用户协议中没有以“规则”字样表示的链接文字所指示的文件不属于本用户协议的组成部分，而是其它内容的协议或有关参考数据，与本协议没有法律上的直接关系。
          </p>
          <p>
            用户在使用启航教育在线提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。启航教育在线有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，启航教育在线将在网站上刊载公告，通知予用户。如用户不同意相关变更，必须停止使用“服务”。经修订的协议一经在启航教育在线网公布后，立即自动生效。各类规则会在发布后生效，亦成为本协议的一部分。登录或继续使用“服务”将表示用户接受经修订的协议。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。
          </p>
          <p>
            用户确认本用户协议后，本用户协议即在用户和启航教育在线之间产生法律效力。请用户务必在注册之前认真阅读全部用户协议内容，如有任何疑问，可向启航教育在线咨询。
          </p>
          <p>
            1)无论用户事实上是否在注册之前认真阅读了本用户协议，只要用户点击协议正本下方的“确认”按钮并按照启航教育在线注册程序成功注册为用户，用户的行为仍然表示其同意并签署了本用户协议。
          </p>
          <p>2)本协议不涉及用户与启航教育在线其它用户之间因网络教育而产生的法律关系及法律纠纷。</p>
        </div>
        <div class="agreement_paragraph">
          <h5>二、 定义</h5>
          <p>
            启航教育在线网络教育平台：有关启航教育在线网络教育平台上的术语或图示的含义，详见启航教育在线帮助。
          </p>
          <p>
            用户及用户注册：用户必须是具备完全民事行为能力的自然人。无民事行为能力人、限制民事行为能力人不应注册为启航教育在线用户，其与启航教育在线之间的用户协议自始无效，启航教育在线一经发现，有权立即注销该用户，并追究其使用启航教育在线“服务”的一切法律责任。用户注册是指用户登录启航教育在线网络教育平台，并按要求填写相关信息并确认同意履行相关用户协议的过程。用户因进行交易、获取有偿服务或接触启航教育在线网络教育平台服务器而发生的所有应纳税赋，以及一切硬件、软件、服务及其它方面的费用均由用户负责支付。启航教育在线网站仅作为网络教育培训平台。
          </p>
        </div>
        <div class="agreement_paragraph">
          <h5>三、 用户权利和义务：</h5>
          <h5>所有用户必须遵循：</h5>
          <p>- 遵守所有使用网络服务的网络协议、规定、程序和惯例；</p>
          <p>- 不得使用启航教育在线从事违法活动；</p>
          <p>- 不得干扰或侵犯启航教育在线的正常运行和其他用户的正常使用；</p>
          <p>- 未经允许，不得以任何形式下载或试图下载启航教育在线的任何内容；</p>
          <p>- 用户购买的课程只允许个人使用，不能用于其他目的；</p>
          <p>- 从中国境内向境外传输技术性资料时不得违反中国有关法律、法规。</p>
          <h5>同时用户承诺：</h5>
          <p>（1）不得利用启航教育在线网络教育平台制作、复制、查阅和传播下列信息：</p>
          <p>
            -
            任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；
          </p>
          <p>- 任何教唆他人进行违法犯罪行为的资料；</p>
          <p>- 任何不符合国家法律、法规规定的资料、信息；</p>
          <p>- 任何捏造或者歪曲事实，散布谣言，扰乱社会秩序的信息；</p>
          <p>- 损害启航教育在线及启航教育集团声誉和商业利益的信息；</p>
          <p>（2）不得未经许可而非法进入其它个人或组织电脑系统；</p>
          <p>
            （3）未经允许，不得对启航教育在线网络教育平台中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；
          </p>
          <p>（4）不得故意制作、传播计算机病毒等破坏性程序；</p>
          <p>（5）法律规定的其他义务。</p>
          <p>
            如果用户的行为违背上述两款规定，启航教育在线可以做出独立判断并有权立即取消用户资格。用户应对自己在启航教育在线网络教育平台上的违法行为承担全部法律责任。
          </p>
        </div>
        <div class="agreement_paragraph">
          <h5>基于网络服务的特殊性，用户同意：</h5>
          <p>- 在注册时按照注册提示提供准确用户名和密码以及详尽的个人资料；</p>
          <p>
            -
            在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为启航教育在线提供所有服务的有效身份依据。
          </p>
          <p>- 用户自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；</p>
          <p>
            - 用户应自行负担因使用这种接入方式而产生的上网电话费、上网信息费及教育信息费。
            用户的用户名、密码
          </p>
          <p>
            -
            用户一旦注册成功，成为启航教育在线网络课堂的正式用户后，应当对自己的用户名（亦称帐号）、密码的安全性负全部责任。用户的密码只能由用户自己掌握。
          </p>
          <p>
            -
            对于用户因帐号或密码泄露造成的各种损失，启航教育在线不承担任何责任。用户发现任何非法使用用户帐号的情况，应立即通知启航教育在线。
          </p>
          <p>- 用户应对以其用户名进行的所有活动和事件负责。</p>
          <p>
            -
            一个听课帐号只能由一个用户使用，不允许多个用户使用同一个听课帐号，如果用户违反此规定，启航教育在线将有权将此听课帐号作为无效处理并保留追究法律责任的权利。
          </p>
          <p>
            -
            用户应使用正版课程资料，对于涉嫌盗版听课账号，一经证实，启航教育在线将有权将此听课账号做封号处理并保留追究法律责任的权利。
          </p>
        </div>
        <div class="agreement_paragraph">
          <h5>四、关于网络课堂的说明：</h5>
          <p>
            1、所有网络课堂的听课卡一经购买（包括网上注册、邮局汇款、银行电汇、零售点零售的各种购买方式），都不允许任何形式的退换。听课卡确有质量问题除外。
          </p>
          <p>
            2、听课卡中的金额仅为启航教育在线网络课堂的教育信息费，而不包含上网电话费、上网信息费等。
          </p>
          <p>
            3、用户使用听课卡上标明的帐号和密码登录注册后，听课卡中的金额将自动注入用户帐号。听课卡注册登录后作废。转入用户账号中的金额仅能作为在启航教育在线网络课堂中听课使用，不找零，不兑换现金或其他产品和服务。
          </p>
          <p>
            4、所有类型的听课卡都有截止登录时间，用户应在指定日期前登录网络课堂。如果用户没有在最后期限之前登录网络课堂，听课卡将作自动作废处理，用户自己应对此承担全部责任。
          </p>
          <p>5、用户如果购买套装课程，另须遵守以下规则：</p>
          <p>- 只能听取套装课程范围之内的课程；套装课程范围之外的课程，用户无权使用；</p>
          <p>
            -
            自购买之日起30天内，课程未使用或只产生了4条以内的听课记录，用户可以申请更换网络课堂中的其他套装课程；
          </p>
          <p>- 对于套装课程，学员在规定的有效期内可重复学习。</p>
          <p>
            6、OEM卡（非经购买而是由于购买其它公司商品获得的赠品）与其它类型听课卡相比有其特定的规则，用户应遵守以下规则：
          </p>
          <p>- OEM卡的选课范围已预先设定好，用户应在此范围内选课而不能变更；</p>
          <p>- 用户应在OEM卡规定的截止日期前登录课堂，登录课堂后应在听课有效期内课程学习；</p>
          <p>- OEM卡不能续费；</p>
          <p>
            -
            与其它类型的听课卡相同，OEM卡不能进行任何形式的退费，也不允许将余额转至套装课程或其他类型的课程中。
          </p>
        </div>
        <div class="agreement_paragraph">
          <h5>五、启航教育在线的权利和义务：</h5>
          <p>
            启航教育在线有义务在现有技术上维护整个网络教育平台的正常运行，并努力提升和改进技术，使用户网络教育活动得以顺利进行；
          </p>
          <p>
            对用户在注册使用启航教育在线网络教育平台中所遇到的与交易或注册有关的问题及反映的情况，启航教育在线应及时作出回复；
          </p>
          <p>
            对于用户在启航教育在线网网络教育平台上的不当行为或其它任何启航教育在线认为应当终止服务的情况，启航教育在线有权随时作出删除相关信息、终止服务提供等处理，而无须征得用户的同意；
            启航教育在线应本着诚实信用的原则向用户提供远程教育服务，不得随意中断或停止提供该项服务。但由于不可抗力或者其它非人为因素造成的服务的中断或停止，启航教育在线不承担任何相应的责任。
          </p>
          <p>
            启航教育在线网站内以任何形式表现的作品（包括但不限于文字、软件、声音、图片、录像、表格、电子邮件等）的著作权，由作品的著作权人和北京启航教育迅程网络科技股份有限公司共同享有，用户未经许可，不得擅自对启航教育在线的包括电子课件在内的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法等相关法律、法规的活动。对侵犯启航教育在线知识产权的个人和组织，北京启航教育迅程网络科技股份有限公司和作品的著作权人将依法追究其民事或刑事责任。
          </p>
          <p>
            启航教育在线享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务。
            许可使用权。启航教育在线对用户在网上发表的供学习交流的作品，享有独家的出版、发行和复制的权利。用户以此授予启航教育在线及其关联公司独家的、全球通用的、永久的、免费的许可使用权利
            (并有权在多个层面对该权利进行再授权)，使启航教育在线及其关联公司有权(全部或部份地)
            使用、复制、修订、改写、发布、翻译、分发、执行和展示用户的全部资料数据（包括但不限于注册资料、交易行为数据及全部展示于网站的各类信息）或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内；
          </p>
          <p>
            启航教育在线会在用户的计算机上设定或取用启航教育在线cookies。
            启航教育在线允许那些在启航教育在线网页上发布广告的公司到用户计算机上设定或取用 cookies
            。 在用户登录时获取数据，启航教育在线使用cookies可为用户提供个性化服务。 如果拒绝所有
            cookies，用户将不能使用需要登录的启航教育在线产品及服务内容。
          </p>
          <h5>用户协议的修改和完善：</h5>
          <p>
            1、启航教育在线将根据互联网的发展和法律、法规的变化，在认为必要时可以单方面修改用户协议;
          </p>
          <p>
            2、本用户协议一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动放弃获得的网络服务。如果用户继续享用网络服务，则视为接受用户协议的变动。当发生争议时，应以最新用户协议的内容为准。启航教育在线有权根据实际情况，调整网络课程的任课教师，该教师如与宣传材料不符以实际任课教师为准。启航教育在线将最大限度的保护用户的听课质量。
          </p>
        </div>
        <div class="agreement_paragraph">
          <h5>六、服务的中断和终止：</h5>
          <p>
            用户同意，在启航教育在线未向用户收取服务费的情况下，启航教育在线可自行全权决定以任何理由
            (包括但不限于启航教育在线认为用户已违反本协议的字面意义和精神，或以不符合本协议的字面意义和精神的方式行事，或用户在超过90天的时间内未以用户的账号及密码登录网站等)
            终止用户的“服务”密码、账户 (或其任何部份)
            或用户对“服务”的使用，并删除（不再保存）用户在使用“服务”中提交的任何资料。同时启航教育在线可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。账号终止后，启航教育在线没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。
            此外，用户同意，启航教育在线不就终止用户接入“服务”而对用户或任何第三者承担任何责任。
          </p>
          <p>
            如用户向启航教育在线提出注销启航教育在线网注册用户身份时，经启航教育在线审核同意，由启航教育在线注销该注册用户，用户即解除与启航教育在线的用户协议关系。但注销该用户账号后，启航教育在线仍保留下列权利：
          </p>
          <p>① 用户注销后，启航教育在线有权保留该用户的注册数据及以前的行为记录；</p>
          <p>
            ②
            用户注销后，如用户在注销前在启航教育在线网络教育平台上存在违法行为或违反合同的行为，启航教育在线仍可行使本用户协议所规定的权利。
          </p>
          <h5>在下列情况下，启航教育在线可以通过注销用户的方式终止服务：</h5>
          <p>
            ①
            在用户违反本用户协议相关规定时，启航教育在线有权终止向该用户提供服务。启航教育在线将在中断服务时通知用户。但如该用户在被启航教育在线终止提供服务后，再一次直接或间接或以他人名义注册为启航教育在线用户的，启航教育在线有权再次单方面终止向该用户提供服务；
          </p>
          <p>
            ②
            如启航教育在线通过用户提供的信息与用户联系时，发现用户在注册时填写的电子邮箱已不存在或无法接收电子邮件的，经启航教育在线以其它联系方式通知用户更改，而用户仍未能提供新的电子邮箱地址的，启航教育在线有权终止向该用户提供服务；
          </p>
          <p>
            ③
            一旦启航教育在线发现用户注册数据中主要内容是虚假的，启航教育在线有权随时终止向该用户提供服务；
          </p>
          <p>④ 用户协议终止或更新时，用户明示不愿接受新的用户协议的；</p>
          <p>⑤ 它启航教育在线认为需终止服务的情况。</p>
        </div>
        <div class="agreement_paragraph">
          <h5>七、责任范围：</h5>
          <p>
            用户明确理解和同意，启航教育在线不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿
            (无论启航教育在线是否已被告知该等损害赔偿的可能性)：
          </p>
          <p>（1）使用或未能使用“服务；</p>
          <p>（2）第三方未经批准的接入或第三方更改用户的传输数据或数据；</p>
          <p>
            （3）第三方对“服务”的声明或关于“服务”的行为；或非因启航教育在线的原因而引起的与“服务”有关的任何其它事宜，包括疏忽；
          </p>
          <p>
            （4）用户明确理解并同意，如因其违反有关法律或者本协议之规定，使启航教育在线遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对启航教育在线提供补偿，包括合理的律师费用等。
            担保责任
            启航教育在线不担保其服务一定能够满足用户的要求，也不担保其服务不会因各种客观原因中断。启航教育在线拒绝提供担保，由用户自己承担系统受损或资料丢失的风险和责任。
          </p>
        </div>
        <div class="agreement_paragraph">
          <h5>八、隐私权政策：</h5>
          <h5>适用范围：</h5>
          <p>① 用户注册启航教育在线账户时，用户根据启航教育在线要求提供的个人注册信息；</p>
          <p>
            ②
            在用户使用启航教育在线服务，参加启航教育在线活动，或访问启航教育在线网页时，启航教育在线自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录；
          </p>
          <p>
            ③ 启航教育在线收集到的用户在使用启航教育在线的有关数据，包括但不限于购买、听课等行为；
          </p>
          <p>④ 启航教育在线通过合法途径从商业伙伴处取得的用户个人数据。</p>
          <h5>信息使用：</h5>
          <p>① 启航教育在线不会向任何人出售或出借用户的个人信息，除非事先得到用户的许可；</p>
          <p>
            ②
            启航教育在线亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，启航教育在线有权立即终止与该用户的用户协议，查封其账号；
          </p>
          <p>
            ③
            为服务用户的目的，启航教育在线可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与启航教育在线合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息（后者需要用户的事先同意）。
          </p>
          <h5>信息披露：</h5>
          <p>用户的个人信息将在下述情况下部分或全部被披露：</p>
          <p>① 经用户同意，向第三方披露；</p>
          <p>
            ②
            如用户是合资格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
          </p>
          <p>③ 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
          <p>④ 如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；</p>
          <p>⑤ 为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；</p>
          <p>⑥ 其它启航教育在线根据法律或者网站政策认为合适的披露。</p>
          <h5>信息安全：</h5>
          <p>① 启航教育在线账户有安全保护功能，请妥善保管用户的账户及密码信息；</p>
          <p>
            ②
            如果用户发现自己的个人信息泄密，尤其是启航教育在线账户及密码发生泄露，请用户立即联络启航教育在线客服，以便启航教育在线采取相应措施。
          </p>
          <h5>Cookie的使用：</h5>
          <p>① 通过启航教育在线所设Cookie所取得的有关信息，将适用本政策；</p>
          <p>
            ②
            在启航教育在线上发布广告的公司通过广告在用户计算机上设定的Cookies，将按其自己的隐私权政策使用；
          </p>
          <p>
            ③ 编辑和删除个人信息的权限：
            用户可以点击“我的课堂”对用户的个人信息进行编辑和删除，除非启航教育在线另有规定；
          </p>
          <p>④ 政策修改：启航教育在线保留对本隐私权政策作出不时修改的权利。</p>
        </div>
        <div style="margin-bottom: 26px" class="agreement_paragraph">
          <h5>九、法律与管辖：</h5>
          <p>
            本用户协议根据现行中华人民共和国法律法规制定。如发生协议条款与中华人民共和国法律法规相抵触时，则这些条款将完全按法律法规的规定重新解释，本用户协议的其它条款仍对启航教育在线和用户具有法律约束力。因本用户协议而发生的任何争议应向对北京市海淀区有管辖权的人民法院提起诉讼。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.agreement_content {
  padding: 40px 36px;
  overflow-y: scroll;
  padding-bottom: 0px;
  -webkit-overflow-scrolling: touch;
}

.agreement_title {
  color: #000;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  text-align: center;
  margin-bottom: 24px;
}

.agreement_paragraph h5 {
  margin: 20px 0;
  color: #000;
  font-weight: 700;
  font-size: 20px;
  line-height: 36px;
}

.agreement_paragraph p {
  margin-bottom: 10px;
  color: #333333;
  font-size: 16px;
  line-height: 36px;
  text-indent: 24px;
}

.agreement_text {
  height: 704px;
  overflow: scroll;
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {
  },
};
</script>
